module.exports = __webpack_public_path__ + "img/marui_yurakucho_banner.e5fd013a.jpeg";